import { createRouter, createWebHistory } from 'vue-router';
import FormenBewerter from '@/views/FormenBewerter.vue';
import AccountPage from '@/views/AccoutPage.vue';
import AboutPage from '@/views/AboutPage.vue';
import CategoryChooser from '@/views/CategoryChooser.vue';
import RegistrierenSeite from '@/views/RegistrierenSeite.vue';
import LoginPage from '@/views/LoginPage.vue';
import LochGenerator from '@/views/LochGenerator.vue';
import ImpressumPage from '@/views/ImpressumPage.vue';
import DatenschutzPage from '@/views/DatenschutzPage.vue';

const routes = [
  { 
    path: '/', 
    name: 'FormenBewerter', 
    component: FormenBewerter 
  },
  { 
    path: '/accountpage', // Changed to lowercase
    name: 'AccountPage', 
    component: AccountPage,
    meta: { requiresAuth: true }
  }, { 
    path: '/aboutpage', // Changed to lowercase
    name: 'AboutPage', 
    component: AboutPage,
  },
  { 
    path: '/CategoryChooser', 
    name: 'CategoryChooser', 
    component: CategoryChooser 
  },
  { 
    path: '/registrieren', 
    name: 'RegistrierenSeite', 
    component: RegistrierenSeite 
  },
  {
    path: '/lochgenerator',
    name: 'LochGenerator',
    component: LochGenerator
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    props: route => ({ token: route.query.token })  // Pass token as a query parameter
  },
  {
    path: '/impressum',
    name: 'ImpressumPage',
    component: ImpressumPage
  },
  {
    path: '/datenschutz',
    name: 'DatenschutzPage',
    component: DatenschutzPage
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('auth_token='))
      ?.split('=')[1];
      
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;